import gql from 'graphql-tag';

const CAMPAIGN_ORDER_SUBSCRIPTION = gql`
  subscription campaignOrder($where: CampaignOrderSubscriptionWhereInput!) {
    campaignOrder(where: $where) {
      node {
        id
        status
        dspConfig
        aggregateData {
          overallData {
            aggEvents
            aggCost
            aggTotalCost
            aggImpressions
            aggClicks
            aggVWI
            totalObservations
            signupsOverallData
          }
          dayPacingData {
            aggEvents
            aggCost
            aggTotalCost
            aggImpressions
            aggClicks
            aggVWI
            totalObservations
          }
          byDate
          topCreatives
          topPublishers
        }
        pacingData {
          id
          pace
          impressionsLeft
          expectedImpressions
          roas
          ctr
          dailyAvgImpressions
          dailyAvgImpressionsLeft
          daysIntoFlight
          daysLeft
          paceYesterday
          impressionsYesterday
        }
      }
    }
  }
`;

export default CAMPAIGN_ORDER_SUBSCRIPTION;
